/**
 * Polling dell'avanzamento invio di una newsletter (RF-04 / §8.6.3).
 * Interroga GET /newsletters/{id}/progress finché lo stato è SENDING.
 *
 * @param {string|null} id       id newsletter
 * @param {boolean} active       true solo quando la newsletter è in invio (SENDING)
 * @param {{ intervalMs?: number, onFinish?: (data:object)=>void }} [options]
 * @returns {{ status, included, sent, percent }|null} ultimo avanzamento (null se inattivo)
 */
import { useEffect, useRef, useState } from 'react';
import { newslettersApi } from '../services/newsletter/newslettersApi';

export function useSendProgress(id, active, { intervalMs = 3000, onFinish } = {}) {
  const [progress, setProgress] = useState(null);
  const onFinishRef = useRef(onFinish);
  onFinishRef.current = onFinish;

  useEffect(() => {
    if (!id || !active) {
      setProgress(null);
      return undefined;
    }

    let cancelled = false;
    let timer;

    const poll = () => {
      newslettersApi
        .progress(id)
        .then((res) => {
          if (cancelled) return;
          const data = res.data ?? {};
          setProgress(data);
          if (data.status && data.status !== 'SENDING') {
            onFinishRef.current?.(data); // invio concluso (SENT/STOPPED/FAILED)
          } else {
            timer = setTimeout(poll, intervalMs); // continua il polling
          }
        })
        .catch(() => {
          if (!cancelled) timer = setTimeout(poll, intervalMs); // riprova al prossimo tick
        });
    };

    poll();

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [id, active, intervalMs]);

  return progress;
}

export default useSendProgress;
